import * as React from "react";
import { Modal, Button, Input, Form, Select, Table } from "antd";
const FormItem = Form.Item;
import { connect } from "react-redux";
const { TextArea } = Input;


interface IPeikuanProps {
  id: any;
  saveSupplier: any;
  form: any;
  getOrderDetails: any;
  type?: any;
  paymentlist: any;
  group_number: any;
  supplierCode: any;
  go_times: any;
  pfn?: any;
}

// 确认函
class Peikuan extends React.Component<IPeikuanProps, any> {
  state = {
    visible: false,
    content: '',
    refundType: '',
    refundReson: '',
    after_desc: '',
    amount: '',
    refundChannel: '',
    accountType: '',
    account: '',
    fullname: '',
    paymentlist: [],
  };
  constructor(props: IPeikuanProps) {
    super(props);
  }

  paymentlist(id) {
    this.setState({
      visible: true
    })
    const param: any = {
      id: id
    };
    this.props.paymentlist({
      ...param,
      callback: (data) => {
        this.setState({
          paymentlist: data
        });
      }
    });
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }

  show(id) {
    this.paymentlist(id)
    this.setState({
      visible: true
    })
  }

  handleOk = e => {
    this.handleSubmit(e);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values['orderId'] = this.props.id;
        values['lmNumber'] = 'no';
        values['groupNumber'] = this.props.group_number;
        values['supplierCode'] = this.props.supplierCode;
        values['travelTime'] = this.props.go_times;
        const param: any = values;
        this.props.saveSupplier({
          ...param,
          callback: (data) => {
            this.setState({
              visible: false
            })
            this.props.pfn();
            const param2: any = {
              id: this.props.id
            };
            this.props.getOrderDetails({
              ...param2,
              callback: () => { }
            });
          }
        });
      }
    });
  }

  getFormItem = () => {
    const { getFieldDecorator } = this.props.form;
    const resonRules = {
      rules: [
        {
          required: true,
          message: "请选择退款类型!"
        }
      ]
    };
    const supplierAmountRules = {
      rules: [
        {
          required: true,
          message: "请输入供应商赔偿金额"
        }
      ]
    };
    const change_amountRules = {
      rules: [
        {
          required: true,
          message: "请输入换算金额"
        }
      ]
    };
    const verifyPersonRules = {
      rules: [
        {
          required: true,
          message: "请输入供应商核实人"
        }
      ]
    };
    const inputRules = {
      rules: [
        {
          required: false,
        }
      ]
    }

    const reson = getFieldDecorator("reson", resonRules)(
      <Select showSearch className="messge" placeholder="请选择售后原因"  >
        <option value="3">导游服务</option>
        <option value="4">司机迟到、送错酒店等服务问题</option>
        <option value="5">客服原因</option>
        <option value="6">页面描述问题（含价格和产品页面）</option>
        <option value="7">供应商问题（船坏等因素）</option>
        <option value="8">天气原因等不可抗力的因素</option>
        <option value="9">其他</option>
      </Select>
    );

    const supplierAmount = getFieldDecorator("supplierAmount", supplierAmountRules)(
      <Input placeholder="" />
    );

    const change_money = getFieldDecorator("change_money", inputRules)(
      <Select showSearch className="change-money" placeholder="请选择售后原因"  >
        <option value="7">฿</option>
        <option value="8">$</option>
        <option value="9">￥</option>
        <option value="10">AED</option>
        <option value="12">IDR</option>
        <option value="13">AUD</option>
        <option value="14">MYR</option>
        <option value="15">NZD</option>
        <option value="16">MUR</option>
        <option value="17">C$</option>
        <option value="18">円</option>
        <option value="19">₫</option>
        <option value="249">DH</option>
        <option value="251">NPR</option>
        <option value="252">EURO</option>
        <option value="255">Rs</option>
        <option value="256">₱</option>
      </Select>
    );
    const change_amount = getFieldDecorator("change_amount", change_amountRules)(
      <Input className="change-amount" placeholder="" />
    );
    const verifyPerson = getFieldDecorator("verifyPerson", verifyPersonRules)(
      <Input placeholder="" />
    );
    const applyDesc = getFieldDecorator("applyDesc", inputRules)(
      <TextArea placeholder="描述" rows={5} />
    );

    let list: any = [];
    list.push(
      <FormItem key="0" label="售后原因">
        {reson}
      </FormItem>
    );
    list.push(
      <FormItem key="1" label="(UFF) 赔款金额">
        {supplierAmount}
      </FormItem>
    );
    list.push(
      <FormItem key="2" label="金额换算">
        {change_money}{change_amount}
      </FormItem>
    );
    list.push(
      <FormItem key="3" label="供应商核实人">
        {verifyPerson}
      </FormItem>
    );
    list.push(
      <FormItem key="4" label="赔偿单描述">
        {applyDesc}
      </FormItem>
    );
    return list;
  }

  render() {
    const dataSource = this.state.paymentlist;

    const columns = [{
      title: '',
      dataIndex: 'type',
      key: 'type',
    }, {
      title: '订单编号',
      dataIndex: 'number',
      key: 'number',
    }, {
      title: '销售单价*数量',
      dataIndex: 'adult_price',
      key: 'adult_price',
      render: (text, row, index) => {
        return (
          <React.Fragment>
            <p>数量  {row.price}*{row.num} </p>
            <p>成人  {row.adult_price}*{row.adult_num} </p>
            <p>儿童  {row.child_price}*{row.children_num} </p>
          </React.Fragment>
        );
      }
    }, {
      title: '总销售金额',
      dataIndex: 'sale_amount',
      key: 'sale_amount',
    }, {
      title: '交通附加费',
      dataIndex: 'surcharge_amount',
      key: 'surcharge_amount',
    }, {
      title: '优惠券抵扣金额',
      dataIndex: 'discount_fee',
      key: 'discount_fee',
    }, {
      title: '商业折扣',
      dataIndex: 'part_mjz_discount',
      key: 'part_mjz_discounts',
    }, {
      title: '积分抵扣金额',
      dataIndex: 'point_fee',
      key: 'point_fee',
    }, {
      title: '实付金额',
      dataIndex: 'payment',
      key: 'payment',
    }];

    return (
      <React.Fragment>
        <Button type="primary" onClick={this.show.bind(this, this.props.id)}>添加赔偿单</Button>
        <Modal maskClosable={false} onCancel={this.handleCancel} title="添加供应商赔偿单" visible={this.state.visible} width="auto" centered={true} onOk={this.handleOk}>
          <Table bordered={true} pagination={false} dataSource={dataSource} columns={columns} />
          <div className="peikuan">
            <Form>{this.getFormItem()}</Form>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  group_number: state.orderDetails.group_number,
  go_times: state.orderDetails.go_times,
  supplierCode: state.orderDetails.supplierCode,
});

const mapDispatch = dispatch => {
  return {
    saveSupplier: dispatch.orderDetails.saveSupplier,
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
    paymentlist: dispatch.orderDetails.paymentlist,
  };
};

export default Form.create<any>()(
  connect(
    mapState,
    mapDispatch
  )(Peikuan)
);


